import { useEffect, useState } from 'react';
import {
  fetchDeployedModelCatalog,
  type DeployedModelCatalog,
} from '../api';

export function ModelsVersionsPage() {
  const [catalog, setCatalog] = useState<DeployedModelCatalog | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    fetchDeployedModelCatalog()
      .then((result) => {
        if (active) setCatalog(result);
      })
      .catch((reason: unknown) => {
        if (active) {
          setError(reason instanceof Error ? reason.message : 'Failed to load model versions');
        }
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-soft">
        <div className="mb-5">
          <h2 className="text-lg font-semibold text-slate-900">Models Versions</h2>
          <p className="mt-1 text-sm text-slate-500">
            Model releases pinned by the currently deployed backend revision.
          </p>
        </div>

        {error ? (
          <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {error}
          </div>
        ) : !catalog ? (
          <p className="text-sm text-slate-500">Loading model versions…</p>
        ) : (
          <>
            <dl className="mb-5 grid gap-3 rounded-xl bg-slate-50 p-4 text-sm sm:grid-cols-3">
              <div>
                <dt className="text-xs uppercase tracking-wide text-slate-500">Backend</dt>
                <dd className="mt-1 font-mono text-slate-800">{catalog.backend_version}</dd>
              </div>
              <div>
                <dt className="text-xs uppercase tracking-wide text-slate-500">Git revision</dt>
                <dd className="mt-1 font-mono text-slate-800">
                  {catalog.git_commit ?? 'unknown'}
                </dd>
              </div>
              <div>
                <dt className="text-xs uppercase tracking-wide text-slate-500">Branch</dt>
                <dd className="mt-1 font-mono text-slate-800">
                  {catalog.git_branch ?? 'unknown'}
                </dd>
              </div>
            </dl>

            <div className="overflow-x-auto rounded-xl border border-slate-200">
              <table className="min-w-full divide-y divide-slate-200 text-left text-sm">
                <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
                  <tr>
                    <th className="px-4 py-3 font-medium">Model</th>
                    <th className="px-4 py-3 font-medium">Version</th>
                    <th className="px-4 py-3 font-medium">Kind</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {catalog.models.map((model) => (
                    <tr key={`${model.group}/${model.name}`}>
                      <td className="px-4 py-3 font-medium text-slate-900">{model.name}</td>
                      <td className="px-4 py-3 font-mono text-indigo-600">{model.version}</td>
                      <td className="px-4 py-3 font-mono text-slate-600">{model.kind}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
